// Remix icon validation - lightweight approach
export type RemixIconName = string;

// Simple validation function that doesn't require loading all icon names
// This approach uses a more efficient validation method
export function isValidRemixIconName(name: string): name is RemixIconName {
  // Basic validation: check if it's a non-empty string with valid characters
  if (!name || typeof name !== 'string') {
    return false;
  }
  
  // Check for valid icon name pattern (kebab-case with optional numbers)
  const validPattern = /^[a-z0-9]+(-[a-z0-9]+)*$/;

  if (!validPattern.test(name)) {
    return false;
  }
  
  // Check for common Remix icon suffixes
  const validSuffixes = ['-line', '-fill'];
  const hasValidSuffix = validSuffixes.some(suffix => name.endsWith(suffix));
  
  return hasValidSuffix;
}

// Export icon count for reference
export const REMIX_ICON_COUNT = 2173;
